import { Component } from '@angular/core'
import { AssistantOnboardingService } from '../../services/assistant-onboarding.service'

/**
 * First-login onboarding offer card (Epic 4, story 4.7 — design-contract §Surface 1 entry / §Surface 3
 * chrome). A fixed desktop-only accept/decline card driven entirely by `AssistantOnboardingService.offerVisible$`.
 * Accept starts the onboarding tour; decline records a skip. All wiring lives in the service — this
 * component only renders the offer and forwards the two clicks.
 */
@Component({
  selector: 'assistant-onboarding-offer',
  template: `
    <div
      *ngIf="visible$ | async"
      class="e11-hidden lg:e11-flex e11-flex-col e11-fixed e11-bottom-6 e11-right-6 e11-z-[1000] e11-w-96 e11-max-w-[calc(100vw-3rem)]"
      role="dialog"
      aria-modal="false"
      [attr.aria-label]="'Take a quick tour?' | translate"
      data-onboarding-offer
    >
      <e11-card
        [isClickable]="false"
        containerClassOverrides="e11-shadow-xl e11-rounded-md e11-bg-skin-white e11-p-6 e11-border e11-border-skin-app-borders"
      >
        <div class="e11-flex e11-flex-col e11-gap-4">
          <div class="e11-flex e11-items-start e11-gap-2">
            <span class="material-icons-outlined md-24 e11-text-skin-primary-accent">auto_awesome</span>
            <div class="e11-flex e11-flex-col e11-gap-1">
              <h4 class="e11-mb-0 e11-font-primary-demibold e11-text-skin-base">{{ 'Take a quick tour?' | translate }}</h4>
              <p class="e11-mb-0 e11-text-sm e11-text-skin-base">
                {{ "We'll walk you through the menus so you know where everything is — it only takes a minute." | translate }}
              </p>
            </div>
          </div>
          <div class="e11-flex e11-items-center e11-justify-end e11-gap-2">
            <e11-button data-offer-decline [color]="'secondary'" [ghost]="true" [value]="'Maybe later' | translate" (click)="decline()"></e11-button>
            <e11-button data-offer-accept [color]="'primary'" [value]="'Start the tour' | translate" (click)="accept()"></e11-button>
          </div>
        </div>
      </e11-card>
    </div>
  `,
})
export class AssistantOnboardingOfferComponent {
  readonly visible$ = this.onboarding.offerVisible$

  constructor(private onboarding: AssistantOnboardingService) {}

  accept(): void {
    this.onboarding.accept()
  }

  decline(): void {
    this.onboarding.decline()
  }
}
